module.exports = __webpack_public_path__ + "img/welcome_14.2ceb1b2a.jpg";